import { Chart } from 'chart.js';
import { isDarkTheme, THEME_CHANGE_EVENT } from './theme';

/*
  Defaults de Chart.js según el tema (texto de ejes/leyendas y líneas de grilla).
  Canvas no entiende variables CSS, por eso se setean valores concretos.
  Los gráficos ya montados se actualizan al volver a renderizarse.
*/
const applyChartTheme = () => {
  const dark = isDarkTheme();
  Chart.defaults.color = dark ? '#b7bdcb' : '#666';
  Chart.defaults.borderColor = dark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.1)';
  // El plugin tooltip se registra por componente; puede no existir todavía
  if (Chart.defaults.plugins && Chart.defaults.plugins.tooltip) {
    Chart.defaults.plugins.tooltip.backgroundColor = dark ? '#3a3f4d' : 'rgba(0, 0, 0, 0.8)';
  }
};

applyChartTheme();
window.addEventListener(THEME_CHANGE_EVENT, applyChartTheme);

export default applyChartTheme;
